import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const consentSettings = {
  ...commonDefaultSettings,
  text: `<div>I’ve read and agree with <a target="_blank" href="https://elfsight.com">Terms of Service</a> and <a target="_blank" href="https://elfsight.com">Privacy Policy</a></div>`,
  fieldID: 'consent'
};
